export const navBoards = [
  { name: '社区广场', icon: 'ri-earth-line' },
  { name: '热门板块', icon: 'ri-fire-line' },
  { name: '今日话题', icon: 'ri-chat-smile-line' },
  { name: '内容分类', icon: 'ri-apps-2-line' },
  { name: '圈子入口', icon: 'ri-compass-3-line' },
];

export const updateList = [
  { text: '【热】#数码研究所# 新款旗舰续航实测出炉，评论区吵翻了', hot: true },
  { text: '今日广场新增 1.2 万条讨论，影视瓜田最活跃', hot: false },
  { text: '广场话题「周末你宅家干什么」正在刷屏', hot: false },
  { text: '职场茶水间上新职场避坑合集，收藏量破万', hot: false },
  { text: '美食探店党打卡 50 家小馆，本周榜单已更新', hot: false },
];

export const heroCategories = ['全部话题', '吃瓜现场', '生活日常', '数码前沿', '影视剧综', '游戏开黑'];

export const boards = [
  { name: '广场闲聊区', tag: '官方热门', desc: '不限题材的广场主广场，今天都在聊什么', active: true, tint: 'bg-orange-100 text-orange-700' },
  { name: '数码研究所', tag: '硬核评测', desc: '手机、电脑与智能硬件，实测党聚集地', active: false, tint: 'bg-red-100 text-red-700' },
  { name: '影视瓜田', tag: '追剧吃瓜', desc: '影视剧综资讯与观后感，热播一网打尽', active: false, tint: 'bg-amber-100 text-amber-700' },
  { name: '游戏开黑局', tag: '组队约玩', desc: '端游手游开黑招募与攻略心得分享', active: false, tint: 'bg-orange-100 text-orange-700' },
  { name: '职场茶水间', tag: '职场互助', desc: '求职面试、工作吐槽与职场避坑指南', active: false, tint: 'bg-rose-100 text-rose-700' },
  { name: '生活记录馆', tag: '日常手账', desc: '随手记录生活碎片与城市见闻', active: false, tint: 'bg-amber-100 text-amber-700' },
  { name: '情感树洞', tag: '匿名倾诉', desc: '匿名投稿倾诉心事，获得善意回应', active: false, tint: 'bg-red-100 text-red-700' },
  { name: '美食探店党', tag: '吃喝地图', desc: '街头小馆与大餐种草，跟着吃就对了', active: false, tint: 'bg-orange-100 text-orange-700' },
];

export const plazaTopics = [
  { board: '广场闲聊区', title: '你们通勤路上一般都在干嘛？我先说我，全靠听播客续命', heat: '2.8万', replies: '436', pin: true },
  { board: '数码研究所', title: '花 4999 换新机用了一周，这条优缺点总结建议先看再买', heat: '1.6万', replies: '289', pin: false },
  { board: '影视瓜田', title: '熬夜刷完新剧大结局，这反转我服气，评论区慎入剧透', heat: '2.1万', replies: '352', pin: false },
  { board: '职场茶水间', title: '空窗三个月拿到 offer 的经验帖，面试被挂不要慌', heat: '9800', replies: '167', pin: false },
  { board: '生活记录馆', title: '下班路上随手拍的晚霞，今天也是被治愈的一天', heat: '1.2万', replies: '203', pin: false },
  { board: '情感树洞', title: '匿个名：和认识多年的朋友突然生疏了，正常吗', heat: '8700', replies: '141', pin: false },
];

export const contentGroups = [
  {
    group: '生活圈',
    icon: 'ri-home-4-line',
    items: [
      { name: '柴米油盐', desc: '家务、省钱与生活妙招', count: '120万' },
      { name: '城市漫游', desc: '本地游玩与城市发现', count: '86万' },
      { name: '家居改造', desc: '租房与小屋改造灵感', count: '64万' },
    ],
  },
  {
    group: '兴趣圈',
    icon: 'ri-star-smile-line',
    items: [
      { name: '追剧吃瓜', desc: '剧综资讯与观后讨论', count: '210万' },
      { name: '游戏开黑', desc: '组队约玩与攻略', count: '180万' },
      { name: '二次元小屋', desc: '动画漫画与同人分享', count: '95万' },
    ],
  },
  {
    group: '分享圈',
    icon: 'ri-upload-cloud-2-line',
    items: [
      { name: '摄影手记', desc: '手机摄影与调色思路', count: '58万' },
      { name: '美食探店', desc: '好吃不贵的小店清单', count: '102万' },
      { name: '旅行攻略', desc: '出行计划与避雷指南', count: '77万' },
    ],
  },
  {
    group: '表达圈',
    icon: 'ri-message-3-line',
    items: [
      { name: '树洞倾诉', desc: '匿名情绪与心事', count: '133万' },
      { name: '观点交锋', desc: '热点话题各抒己见', count: '149万' },
      { name: '段子合集', desc: '沙雕日常与梗图', count: '88万' },
    ],
  },
];

export const featuredPosts = [
  { board: '数码研究所', title: '今年旗舰横评出炉：影像、续航、手感谁是六边形战士？', reads: '36万', replies: '1802', tag: '实测', image: 'https://readdy.ai/api/search-image?query=%E6%9C%9D%E9%98%B3%E4%B8%8B%E9%93%B6%E7%81%B0%E8%89%B2%E5%9B%A2%E9%99%A2%E6%80%A7%E8%83%BD%E6%89%8B%E6%9C%BA%E4%B8%8E%E9%9D%99%E7%BD%AE%E6%91%84%E5%83%8F%E5%A4%B4%E7%9A%84%E6%95%B4%E9%BD%90%E6%91%86%E6%94%BE%E7%9F%A5%E8%AF%86%E5%8C%96%E4%B8%93%E4%B8%9A%E6%91%84%E5%BD%B1%E5%9B%BE%E7%89%87%EF%BC%8C%E5%B9%B2%E5%87%80%E7%99%BD%E8%89%B2%E8%83%8C%E6%99%AF%E8%BD%AF%E8%B4%A8%E5%85%89%E6%B8%A9%E5%92%8C&width=1200&height=900&seq=haijiao-f1&orientation=landscape' },
  { board: '影视瓜田', title: '新剧第一集就高能，年度必追预定？我看完来聊聊', reads: '52万', replies: '2940', tag: '热播', image: 'https://readdy.ai/api/search-image?query=%E7%81%AF%E7%81%AB%E6%98%A0%E7%85%A7%E7%9A%84%E5%AE%A4%E5%86%85%E7%94%B5%E5%BD%B1%E6%B0%9B%E5%9B%B4%E5%89%A7%E5%9C%BA%E6%84%9F%E7%85%A7%E6%98%8E%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%B5%8B%E5%85%89%E5%AF%B9%E6%AF%94%E5%8C%BB%E7%94%9F%E8%9E%8D%E8%89%B2%E5%89%A7%E9%9B%86%E6%84%9F%E7%94%BB%E9%9D%A2%EF%BC%8C%E6%B8%A9%E5%92%8C%E5%A4%9C%E8%89%B2%E8%83%B6%E7%89%87%E8%B4%A8%E6%84%9F&width=1200&height=900&seq=haijiao-f2&orientation=landscape' },
  { board: '游戏开黑局', title: '开黑语音初体验：五连坐上分，队友配合直接拉满', reads: '28万', replies: '1190', tag: '开黑', image: 'https://readdy.ai/api/search-image?query=%E6%9A%97%E8%89%B2%E9%94%AE%E7%9B%98%E9%B8%A3%E5%85%89%E4%B8%8ERGB%E5%85%89%E6%95%88%E7%9A%84%E6%B8%B8%E6%88%8F%E8%AE%BE%E5%A4%87%E5%A4%9C%E6%99%AF%E7%94%B5%E7%AB%9E%E6%B0%9B%E5%9B%B4%E5%9B%BE%E7%89%87%EF%BC%8C%E5%86%B7%E8%B0%83%E8%93%9D%E7%B4%AB%E5%85%89%E5%92%8C%E6%B7%B1%E8%89%B2%E8%83%8C%E6%99%AF&width=1200&height=900&seq=haijiao-f3&orientation=landscape' },
  { board: '美食探店党', title: '巷子里藏着的宝藏小店，人均 30 吃到扶墙出', reads: '41万', replies: '2260', tag: '探店', image: 'https://readdy.ai/api/search-image?query=%E8%A1%97%E8%A7%92%E5%B0%8F%E5%BA%97%E9%A4%90%E6%A1%8C%E4%B8%8A%E7%9A%84%E4%B8%AD%E5%BC%8F%E7%BE%8E%E9%A3%9F%E5%A4%A7%E7%9B%98%E6%91%86%E7%9B%98%EF%BC%8C%E7%83%AD%E6%B0%94%E8%85%BE%E8%85%BE%E9%9F%B3%E8%89%B2%E6%98%8E%E4%BA%AE%E8%A7%92%E5%BA%A6%E5%96%9C%E4%BA%AE%E6%96%87%E5%AD%97%E6%91%84%E5%BD%B1&width=1200&height=900&seq=haijiao-f4&orientation=landscape' },
  { board: '生活记录馆', title: '记录在陌生城市独居的第 300 天，一个人也要好好吃饭', reads: '19万', replies: '860', tag: '日常', image: 'https://readdy.ai/api/search-image?query=%E6%B8%A9%E9%A6%A8%E7%9A%84%E5%85%AC%E5%AF%93%E7%AA%97%E8%BE%B9%E5%B0%8F%E9%A4%90%E6%A1%8C%E4%B8%8A%E7%9A%84%E6%97%A9%E9%A4%90%E5%92%8C%E5%92%96%E5%95%A1%E7%9B%85%EF%BC%8C%E5%92%8C%E7%85%A6%E6%9C%A8%E5%8E%A8%E6%88%BF%E6%97%A5%E5%B8%B8%E7%94%9F%E6%B4%BB%E7%94%BB%E9%9D%A2%E6%B0%9B%E5%9B%B4%E6%84%9F%E7%9C%9F%E5%AE%9E%E8%BD%AF%E8%B4%A8%E5%85%89&width=1200&height=900&seq=haijiao-f5&orientation=landscape' },
  { board: '观点交锋', title: '「先攒钱还是先享受生活」：广场吵了一天还没结论', reads: '45万', replies: '3180', tag: '热议', image: 'https://readdy.ai/api/search-image?query=%E6%9C%A8%E8%B4%A8%E4%B9%A6%E6%A1%8C%E4%B8%8A%E6%91%86%E6%94%BE%E7%9A%84%E7%AC%94%E8%AE%B0%E6%9C%AC%E9%92%B1%E5%8C%85%E5%92%8C%E5%92%96%E5%95%A1%E7%9A%84%E5%B9%B3%E9%9D%A2%E6%91%84%E5%BD%B1%EF%BC%8C%E5%B9%B2%E5%87%80%E6%97%A5%E5%B8%B8%E4%BC%9A%E8%AE%A1%E5%B0%8F%E7%89%A9%E5%92%8C%E8%BD%AF%E8%B4%A8%E5%85%89&width=1200&height=900&seq=haijiao-f6&orientation=landscape' },
];

export const leaderPosts = [
  { rank: 1, title: '最近流行起来的「电子榨菜」你都看过哪些？', heat: '8.9万', board: '广场闲聊区' },
  { rank: 2, title: '手把手教你在家复刻那家店的招牌菜，真的不难', heat: '7.6万', board: '美食探店党' },
  { rank: 3, title: '那些年踩过的职场坑，新人避雷清单请收好', heat: '6.3万', board: '职场茶水间' },
  { rank: 4, title: '手机摄影进阶：这 5 个参数调对，随手都是大片', heat: '5.1万', board: '摄影手记' },
  { rank: 5, title: '周末去哪玩？本地人私藏的城市小众路线', heat: '4.8万', board: '城市漫游' },
  { rank: 6, title: '熬夜党自救指南，附我亲测有效的作息表', heat: '4.2万', board: '生活记录馆' },
];

export const downloadPoints = ['广场实时讨论', '板块一键关注', '帖子离线收藏', '开黑组队通知'];